import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { ApiService, HttpMethod } from '../api/api.service';
import {
  AiBudgetSnapshot,
  AiUsageEventsPage,
  AiUsageSnapshot,
} from './ai-budget.types';

@Injectable({ providedIn: 'root' })
export class AiBudgetService {
  constructor(private readonly api: ApiService) {}

  getOrgBudget(orgId: number): Observable<AiBudgetSnapshot> {
    return from(
      this.api.call<AiBudgetSnapshot>(
        HttpMethod.GET,
        `organizations/${orgId}/ai-budget`,
      ),
    );
  }

  setOrgBudget(orgId: number, capUsd: number): Observable<AiBudgetSnapshot> {
    return from(
      this.api.call<AiBudgetSnapshot>(
        HttpMethod.PATCH,
        `organizations/${orgId}/ai-budget`,
        { capUsd },
      ),
    );
  }

  getOrgUsage(orgId: number): Observable<AiUsageSnapshot> {
    return from(
      this.api.call<AiUsageSnapshot>(
        HttpMethod.GET,
        `organizations/${orgId}/ai-usage`,
      ),
    );
  }

  listOrgEvents(
    orgId: number,
    opts: { limit?: number; cursor?: number } = {},
  ): Observable<AiUsageEventsPage> {
    const queryParams = new URLSearchParams();
    if (opts.limit !== undefined) {
      queryParams.set('limit', String(opts.limit));
    }
    if (opts.cursor !== undefined) {
      queryParams.set('cursor', String(opts.cursor));
    }
    const queryString = queryParams.toString();
    const path = `organizations/${orgId}/ai-usage/events${
      queryString ? `?${queryString}` : ''
    }`;

    return from(this.api.call<AiUsageEventsPage>(HttpMethod.GET, path));
  }
}
